import { render, staticRenderFns } from "./CopyLinkButton.vue?vue&type=template&id=2d5c446b"
import script from "./CopyLinkButton.vue?vue&type=script&lang=js"
export * from "./CopyLinkButton.vue?vue&type=script&lang=js"
import style0 from "./CopyLinkButton.vue?vue&type=style&index=0&id=2d5c446b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports